import type { ReactNode } from 'react';
import { cn } from '@/lib/utils';
import { line, muted } from './tokens';

/** A small label: the licence, the permitted use, whether it is on, what an action is made for. */
export function Chip({ children, tone = 'plain' }: { children: ReactNode; tone?: 'plain' | 'on' | 'use' }) {
  return (
    <span
      className={cn(
        'inline-flex items-center rounded-md border px-1.5 py-0.5 text-xs font-medium leading-tight',
        line,
        tone === 'on' ? 'text-emerald-700 dark:text-emerald-400' : tone === 'use' ? 'text-amber-700 dark:text-amber-400' : muted,
      )}
    >
      {children}
    </span>
  );
}
